export const IsAlmacenReproceso = (formValues) => {
    if (!formValues) return false;
    if (!formValues.almacen) return false;

    return formValues.almacen && formValues.almacen.es_reproceso;
};
